import * as React from 'react'
import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'

import FilterButton from '@user/components/Filters'

import type {
  ActivitySummaryDTO,
  ActivitySummaryFilterSet,
} from '../../typings'
import { useData, useHandlers } from './hooks'
import { FilterContent } from './FilterContent'
import { clearedFilters } from '../../constants'
import { FilterChipListWrapper } from '@user/components/Filters/FilterChip'

export function ActivitySummaryFilters() {
  const { filterSet, defaultFilters } = useData()

  const { applyFilters } = useHandlers()

  const showChips = filterSet.appliedCount > 0
  const buttonML = showChips ? 1 : 'auto'

  return (
    <Stack
      direction="row"
      alignItems="center"
      p={2}
      bgcolor="#FAFAFA"
      justifyContent="flex-end"
    >
      {showChips && (
        <FilterChipListWrapper<ActivitySummaryDTO, ActivitySummaryFilterSet>
          filterSet={filterSet}
          applyCallback={applyFilters}
          clearedFilters={clearedFilters}
          width="85%"
        />
      )}

      <Box ml={buttonML} whiteSpace="nowrap" borderBottom="1px">
        <FilterButton<ActivitySummaryDTO, ActivitySummaryFilterSet>
          hideOrderBy
          orderOptions={[]}
          initialValues={filterSet}
          applyCallback={applyFilters}
          clearedValues={clearedFilters}
          defaultValues={defaultFilters}
          filterComponent={FilterContent}
        />
      </Box>
    </Stack>
  )
}
